import * as VALIDITY_PROPERTIES from './validityProperties';
import * as FILTERS from './filters';
import DEFAULT_LOCATION from './defaultLocation';
import STATES from './states';
import PROFILE_REDIRECTS from './profileRedirects';
import SUBURB_REDIRECTS from './suburbRedirects';
import CATEGORY_EXCLUSIONS from './categoryExclusions';
import LEGACY_CATEGORY_REDIRECTS from './legacy/legacyCategoryRedirects';
import CATEGORY_REDIRECTS from './legacy/categoryRedirects';
import DIGITAL_MARKETING_LISTVIEW_REDIRECTS from './digitalMarketingListviewRedirects';
import LISTVIEW_TITLE_TAGS from './listviewTitleTags';
import LISTVIEW_SECONDARY_HEADING from './listviewSecondaryHeading';
import PROFILE_STATUS from './profile';
import { LISTING_POST_STATES } from './listingPosts';
import LINKS from './links';

import {
  PlumbersIcon,
  BuildersIcon,
  MechanicsIcon,
  DentistIcon,
  MassageIcon,
  CleanersIcon,
  HairdressersIcon,
} from '../assets/landing';

const MODALS = {
  ENQUIRY_FORM: 'EnquiriesForm',
  REVIEW_FORM: 'ReviewForm',
  REVIEW_UPDATE_FORM: 'ReviewUpdateForm',
  REVIEW_PERSONIV_FORM: 'ReviewPersonivForm',
  SUGGEST_EDIT_FORM: 'SuggestEditForm',
  MODAL_CONFIRMATION: 'ModalConfirmation',
  REVIEW_RATING_CONFIRMATION: 'ReviewRatingConfirmation',
  DATE_PICKER: 'DatePicker',
  HEADER_SLIDE_MENU: 'HeaderSlideMenu',
  SEARCH_AUTOSUGGEST: 'SearchAutoSuggest',
  CLAIM_BUSINESS_FORM: 'ClaimBusinessForm',
  SHARE: 'Share',
  FILTERS_MOBILE: 'FiltersMobile',
  FILTERS_SORT_BY_MOBILE: 'FiltersSortByMobile',
  ADD_A_BUSINESS: 'AddABusiness',
  TRADING_HOURS: 'TradingHours',
  PROFILE_TRADING_HOURS: 'ProfileTradingHours',
  USER_LOGOUT: 'UserLogout',
  FAVOURITES_MODAL: 'FavouritesModal',
  USER_REVIEW_DELETE: 'UserReviewDelete',
  WELCOME_SUCCESS: 'welcomeSuccessModal',
};

const COOKIES = {
  USER_LAST_LOCATION: 'user_last_location',
  REVIEW_FORM: 'ReviewForm',
  NOTIFICATION_ALERT_BANNER: '_ls_notification_alert_banner',
  LS_USER: 'ls_user',
};

const STANDARD_PHONE_REGEX = '^[0-9 +]{4,12}$';
const PHONE_REGEX =
  '(^(1300|1800|1900|1902)(| )[0-9]{3}(| )[0-9]{3}$)|(^0[2|3|7|8]{1}(| )[0-9]{4}(| )[0-9]{4}$)|(^13(| )[0-9]{4}$)|(^13[0-9]{1}(| )[0-9]{3}$)|((^0[4-5][0-9]{2,3})(| )[0-9]{3}(| )[0-9]{3}$)|((^61(| )[4-5][0-9]{0,4})(| )[0-9]{3,4}(| )[0-9]{3,4}$)';
const MISSING_AREACODE_REGEX = '^[0-9]{4}(| )[0-9]{4}$';
const MOBILE_REGEX =
  '^(0[4-5][0-9]{2,3})(| )[0-9]{3}(| )[0-9]{3}$|(^61(| )[4-5][0-9]{0,4})(| )[0-9]{3,4}(| )[0-9]{3,4}$';
const EMAIL_REGEX = '';
const CHARACTERS_ONLY_REGEX = "^[a-zA-Z-',]+(s{0,1}[a-zA-Z-', ])*$";
const ALPHANUMERIC_REGEX = "^[a-zA-Z0-9-_ ',.&]*$";
const LISTVIEW_PAGE_SIZE = 50;

const SORT_BY_FILTER_ICONS = {
  suggested: 'icon-generalsearchlarge',
  distance: 'icon-generalpindropmini',
};

const TRADING_HOURS_FILTER_ICONS = {
  open: 'icon-generaltime',
  open247: 'icon-weathermoon3',
};

const WAYS_TO_PAY_FILTER_ICONS = {
  interestFreePlans: 'icon-generalquote',
  humm: 'icon-categorycarparkpayanddisplay',
  afterPay: 'icon-categorycarparkpayanddisplay',
  zipPay: 'icon-categorycarparkpayanddisplay',
  openpay: 'icon-categorypaymenttypecards',
  bitcoin: 'icon-categorycarparkpayanddisplay',
  bulkBilling: 'icon-categoryplaceofworship',
  seniorsDiscount: 'icon-categoryorganisations',
  payPal: 'icon-categorypaymenttypemobile',
  hicaps: 'icon-categoryprofessionalservices',
  amex: 'icon-categorypaymenttypecards',
  visa: 'icon-categorypaymenttypecards',
  googlePay: 'icon-categorypaymenttypemobile',
  giftVoucher: 'icon-categorypaymenttypecards',
  fullyInsured: 'icon-categoryinsurance',
  eftpos: 'icon-categorypaymenttypecards',
  eft: 'icon-categorypaymenttypecards',
  directDebit: 'icon-generalbook',
  cheque: 'icon-categoryatmdepositcheque',
  cash: 'icon-categoryfinancialservices',
  bpay: 'icon-categorycomputers',
  bartercard: 'icon-categorypaymenttypecards',
  applePay: 'icon-categorypaymenttypemobile',
  account: 'icon-categorylibraries',
  mastercard: 'icon-categorypaymenttypecards',
  afterpay: 'icon-categorycarparkpayanddisplay',
  giftVouchers: 'icon-categoryartsandentertainment',
  paypal: 'icon-categorypaymenttypemobile',
  seniorsDiscounts: 'icon-categoryorganisations',
  default: 'icon-categorypaymenttypecards',
};

const FILTER_ICONS = {
  ...WAYS_TO_PAY_FILTER_ICONS,
  ...TRADING_HOURS_FILTER_ICONS,
  ...SORT_BY_FILTER_ICONS,
};

const QUOTES_SERVICES = {
  Installation: 'installation',
  Repairs: 'repair',
  'On-going help': 'ongoing',
  'One-off job': 'oneOff',
  'Commercial project': 'commercial',
  Other: 'other',
};

const QUOTES_SERVICES_REVERSE = {
  installation: 'Installation',
  repair: 'Repairs',
  ongoing: 'On-going help',
  oneOff: 'One-off job',
  commercial: 'Commercial project',
  other: 'Other',
};

const TRADING_HOURS_CAPTIONS = [
  {
    label: 'Open',
    value: 'Open',
    open: '08:30',
    close: '17:00',
    hasOpenClose: true,
  },
  {
    label: 'Open 24hrs',
    value: 'Open 24hrs',
    hasOpenClose: false,
  },
  {
    label: 'Flexible Hours',
    value: 'Flexible Hours',
    hasOpenClose: false,
  },
  {
    label: 'By Appointment',
    value: 'By Appt',
    open: '08:30',
    close: '17:00',
    hasOpenClose: true,
  },
  {
    label: 'Extended Hours',
    value: 'Extended Hours',
    hasOpenClose: false,
  },
  {
    label: 'On Call',
    value: 'On Call',
    hasOpenClose: false,
  },
  {
    label: 'After Hours',
    value: 'After Hours',
    hasOpenClose: false,
  },
  {
    label: 'Emergency',
    value: 'Emergency',
    hasOpenClose: false,
  },
  {
    label: 'Closed',
    value: 'Closed',
    hasOpenClose: false,
  },
  {
    label: 'Temporarily Closed',
    value: 'Temporarily Closed',
    hasOpenClose: false,
  },
  {
    label: 'Online Only',
    value: 'Online Only',
    hasOpenClose: false,
  },
  {
    label: 'Take Away Only',
    value: 'Take Away Only',
    open: '08:30',
    close: '17:00',
    hasOpenClose: true,
  },
  {
    label: 'Delivery Only',
    value: 'Delivery Only',
    open: '08:30',
    close: '17:00',
    hasOpenClose: true,
  },
];

const TRADING_HOURS_CAPTION_COLORS = {
  default: '#00a699',
  Open: '#00a699',
  'Open Today': '#00a699',
  'Open 24hrs': '#00a699',
  'Flexible Hours': '#00a699',
  'By Appt': '#00a699',
  'Extended Hours': '#00a699',
  Emergency: '#e48f37',
  'On Call': '#e48f37',
  'After Hours': '#e48f37',
  Closed: '#f16159',
  'Temporarily Closed': '#f16159',
  'Online Only': '#757575',
  'Take Away Only': '#757575',
  'Delivery Only': '#757575',
  'Closing Soon': '#ed8a39',
};

const DEFAULT_TRADING_HOURS = [
  {
    day: 'Monday',
    open: '',
    close: '',
    caption: 'Closed',
    validate: true,
    sort: 1,
  },
  {
    day: 'Tuesday',
    open: '',
    close: '',
    caption: 'Closed',
    validate: true,
    sort: 2,
  },
  {
    day: 'Wednesday',
    open: '',
    close: '',
    caption: 'Closed',
    validate: true,
    sort: 3,
  },
  {
    day: 'Thursday',
    open: '',
    close: '',
    caption: 'Closed',
    validate: true,
    sort: 4,
  },
  {
    day: 'Friday',
    open: '',
    close: '',
    caption: 'Closed',
    validate: true,
    sort: 5,
  },
  {
    day: 'Saturday',
    open: '',
    close: '',
    caption: 'Closed',
    validate: true,
    sort: 6,
  },
  {
    day: 'Sunday',
    open: '',
    close: '',
    caption: 'Closed',
    validate: true,
    sort: 7,
  },
  {
    day: 'Pub Hols',
    open: '',
    close: '',
    caption: 'Closed',
    validate: false,
    sort: 8,
  },
];

const POPULAR_INDUSTRIES = [
  {
    name: 'Plumbers',
    icon: PlumbersIcon,
  },
  {
    name: 'Builders',
    icon: BuildersIcon,
  },
  {
    name: 'Mechanics',
    icon: MechanicsIcon,
  },
  {
    name: 'Hairdressers',
    icon: HairdressersIcon,
  },
  {
    name: 'Cleaners',
    icon: CleanersIcon,
  },
  {
    name: 'Dentists',
    slug: 'dentists',
    icon: DentistIcon,
  },
  {
    name: 'Massage',
    slug: 'massage-therapists',
    icon: MassageIcon,
  },
];

const FREE_BRONZE_CATEGORIES = [
  'accommodation',
  'apartments',
  'asian restaurants',
  'bottle shops',
  'cafes',
  'chinese restaurants',
  'conference & function venues',
  'fast food',
  'food delivery',
  'greek restaurants',
  'hotels',
  'indian restaurants',
  'italian restaurants',
  'malaysian restaurants',
  'mexican restaurants',
  'motels',
  'pizza',
  'restaurants',
  'seafood restaurants',
  'steakhouses',
  'take away food',
  'thai restaurants',
  'things to do',
  'vietnamese restaurants',
  'wedding reception venues',
  'takeaway food',
  'french restaurants',
  'gluten-free restaurants',
  'pop-up restaurants',
  'spanish restaurants',
  'wine tours',
  'beers tours',
  'bar crawl',
  'tapas restaurants',
  'pubs & taverns',
  'taxis',
  'markets',
  'things to do',
  'wine bars',
  'beer tours',
  'cocktail bars',
  'sports bars',
  'rooftop bars',
  'bars',
  'boutiques',
  'nail salons',
  'fitness centres & gyms',
  'personal trainers',
  'yoga',
  'pilates',
  'burgers',
  'fish & chips',
  'waste & recycling centres',
];

const MAX_UPLOADS_PER_PACKAGE = {
  package1: 30,
  package2: 25,
  package3: 20,
  package4: 15,
};

const MAX_PDF_UPLOADS = 10;
const LS_FEATURE_BANNER_URL = 'https://business.localsearch.com.au/';
const LS_PACKAGES_BANNER_URL =
  'https://business.localsearch.com.au/our-services/';
const LS_CAREERS_BANNER_URL = 'https://business.localsearch.com.au/careers/';

const GRAPHQL_ERRORS = {
  INTERNAL_SERVER_ERROR: {
    heading: 'Internal Server Error',
    message: 'Your submission could not be processed. Please try again later.',
  },
  PERSISTED_QUERY_NOT_FOUND: {
    heading: 'Internal Server Error',
  },
  PERSISTED_QUERY_NOT_SUPPORTED: {
    heading: 'Internal Server Error',
  },
  BAD_USER_INPUT: {
    heading: 'Validation Error',
    message: 'Please check your details and try again.',
  },
  GRAPHQL_VALIDATION_FAILED: {
    heading: 'Validation Error',
  },
  GRAPHQL_PARSE_FAILED: {
    heading: 'Validation Error',
  },
  FORBIDDEN: {
    heading: 'Forbidden',
    message: 'You do not have permission to submit this form.',
  },
  UNAUTHENTICATED: {
    heading: 'Unauthenticated',
    message: 'You do not have permission to submit this form.',
  },
};

const ENABLE_USER_MANAGEMENT = true;

const VACCINATION_DISCLAIMER_CATEGORIES = [
  'Vaccinations',
  'Travel Vaccinations',
];

export {
  ENABLE_USER_MANAGEMENT,
  VACCINATION_DISCLAIMER_CATEGORIES,
  VALIDITY_PROPERTIES,
  MODALS,
  PHONE_REGEX,
  MOBILE_REGEX,
  STANDARD_PHONE_REGEX,
  MISSING_AREACODE_REGEX,
  EMAIL_REGEX,
  CHARACTERS_ONLY_REGEX,
  ALPHANUMERIC_REGEX,
  STATES,
  DEFAULT_LOCATION,
  COOKIES,
  LISTVIEW_PAGE_SIZE,
  PROFILE_REDIRECTS,
  SUBURB_REDIRECTS,
  DIGITAL_MARKETING_LISTVIEW_REDIRECTS,
  LEGACY_CATEGORY_REDIRECTS,
  CATEGORY_REDIRECTS,
  TRADING_HOURS_FILTER_ICONS,
  WAYS_TO_PAY_FILTER_ICONS,
  SORT_BY_FILTER_ICONS,
  FILTERS,
  LISTVIEW_TITLE_TAGS,
  QUOTES_SERVICES,
  QUOTES_SERVICES_REVERSE,
  TRADING_HOURS_CAPTIONS,
  TRADING_HOURS_CAPTION_COLORS,
  DEFAULT_TRADING_HOURS,
  CATEGORY_EXCLUSIONS,
  POPULAR_INDUSTRIES,
  FREE_BRONZE_CATEGORIES,
  LISTVIEW_SECONDARY_HEADING,
  MAX_UPLOADS_PER_PACKAGE,
  MAX_PDF_UPLOADS,
  LS_FEATURE_BANNER_URL,
  LS_PACKAGES_BANNER_URL,
  LS_CAREERS_BANNER_URL,
  GRAPHQL_ERRORS,
  LISTING_POST_STATES,
  FILTER_ICONS,
  PROFILE_STATUS,
  LINKS,
};
